import { ScheduleCalendarConfigurationType } from './time-slot.dto'
import { AccountType, CustomerRole, ResidentialType } from './_.dto'
import { PaymentTerm } from './invoice.dto'
import { EmployeeRoleDto } from './technician.dto'
import { CustomerSubContact } from './customer.dto'
import { BlockTimeType, BookingDto } from './booking.dto'

export enum AccountPasswordStatus {
  RESET = 'RESET'
}

export interface AuthenticationData {
  accountInfo?: CurrentAccountInfoResponseDto
  configuration?: ScheduleCalendarConfigurationType
  companyInfo?: CurrentCompanyInfoInfoResponseDto
}

export interface ProfileDto {
  name: string
  contact: string
  avatarUrl?: string
  avatarId?: string
  countryCode?: string
  subContacts?: CustomerSubContact[]
}

export interface ProfileExtraCustomerDto {
  customerRole: CustomerRole
  organizationName?: string

  remark?: string

  paymentTerm: PaymentTerm
  paymentTermValue: number
  designatedAddressLine1?: string
  designatedAddressLine2?: string
  designatedAddressPostalCode?: string
  designatedAddressCity?: string
  designatedAddressCountry?: string
  designatedResidentialType?: ResidentialType

  billingAddressLine1?: string
  billingAddressLine2?: string
  billingAddressPostalCode?: string
  billingAddressCity?: string
  billingAddressCountry?: string
  billingResidentialType?: ResidentialType
  isSameDesignatedAddress?: boolean
  isBlackList: boolean
}

export interface AccountInfoDto {
  id: string
  email: string
  employeeRole?: EmployeeRoleDto
  employeeRoleId?: string
  accountType: AccountType
  socialLogin?: string
  createdAt: Date
  profile?: ProfileDto
  profileExtraCustomer?: ProfileExtraCustomerDto
  isActive: Boolean
  paymentTerm?: PaymentTerm
  paymentTermValue?: number
  suggestContactShow?: string
  subContactId?: string
  requestDeactiveDate?: string
  vendor?: any
  name: string
  companyId?: string
  blockOffEmployees?: BlockOffEmployee[]
  isBlackList: boolean
  noOfBooking?: number
}

export interface CurrentAccountInfoResponseDto {
  id: string
  email: string
  passwordStatus: AccountPasswordStatus
  accountType: AccountType
  profile?: ProfileDto
  adminType: string
}

export interface CurrentCompanyInfoInfoResponseDto {
  name?: string
  email?: string
  tel?: string
  logo?: string
  addressLine1?: string
  addressLine2?: string
  postalCode?: string
  registrationNo?: string
  urgentContact?: string
  urgentEmail?: string
  paynowName?: string
  paynowQRCode?: string
  urgentCountryCode?: string
}

export interface ListAccountInfoResponseDto {
  items: AccountInfoDto[]

  count: number
}
export interface LocationProximity {
  id: string
  name: string
  label: string
}

export interface StripeAccountInfoDto {
  publishableKey: string
  secretKey: string
}

export interface ComplianceInfoDto {
  privacyPolicy: string
  termsAndCondition: string
}

export interface BlockOffEmployee {
  accountId: string
  begin: string // e.g., "08:00AM"
  companyId: string
  createdAt: string // ISO 8601 format
  date: string | null // null for recurring entries
  dayOfWeek: string // e.g., "Monday"
  end: string // e.g., "10:00AM"
  id: string
  ignoreDays: string[] // e.g., ["2025-05-12"]
  modifiedAt: string // ISO 8601 format
  reason: string
  type: BlockTimeType
  bookingId: string
  booking?: BookingDto
}
